(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("clipping-planes", [], factory);
	else if(typeof exports === 'object')
		exports["clipping-planes"] = factory();
	else
		root["clipping-planes"] = factory();
})(self, function() {
return 